import {
  FormControl,
  FormHelperText,
  FormLabel,
  Input,
  InputLabel,
} from "@mui/material";
import { MuiTelInput } from "mui-tel-input";
import { Controller } from "react-hook-form";

const ReactTelInput = (props) => {
  const {
    hookFormControl,
    label,
    varName,
    formLabel,
    disabled = false,
    dataType = "text",
    errorMessage = null,
    helperText = null,
    endAdornment = null,
    defaultCountry = "IN",
    variant = "outlined",
    size = "small",
    required = false,
  } = props;

  return (
    <>
      <Controller
        name={varName}
        control={hookFormControl}
        // defaultValue=""
        render={({ field }) => (
          <FormControl
            error={errorMessage !== null}
            size={size}
            className="w-full"
            variant={variant}
          >
            {formLabel && (
              <FormLabel className="text-[16px] font-['Matter-Medium'] text-black mb-2">
                {formLabel}
              </FormLabel>
            )}
            <MuiTelInput
              id={varName}
              label={label}
              disableFormatting
              size={size}
              required={required}
              variant={variant}
              forceCallingCode={true}
              onlyCountries={["IN"]}
              disableDropdown
              focusOnSelectCountry
              defaultCountry={defaultCountry}
              error={errorMessage !== null}
              disabled={disabled}
              {...field}
              value={!field.value ? "" : field.value}
              InputProps={{
                endAdornment,
                readOnly: props?.readOnly,
                className: "font-['Poppins-Regular'] text-[15px]",
              }}
              InputLabelProps={{
                className: "font-['Poppins-Regular'] text-[15px]",
              }}
            />
            {!errorMessage && helperText && (
              <FormHelperText
                className="ml-0 font-['Poppins-Regular']"
                id="component-info-text"
              >
                {helperText}
              </FormHelperText>
            )}
            {errorMessage && (
              <FormHelperText
                className="ml-0 font-['Poppins-Regular']"
                id="component-error-text"
              >
                {errorMessage}
              </FormHelperText>
            )}
          </FormControl>
        )}
      />
    </>
  );
};

export default ReactTelInput;
